/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import AppRouterDefinition from "./AppRouterDefinition";
import { useAuthenticationContext } from "./Basis/Authentication/AuthenticationContext";
import { useAppBreadcrumbsContext } from "./Basis/Components/AppBreadcrumbsContext";
import { useAppContext } from "./Basis/Components/AppContext";

interface AppRouterListenerProps {
    appRouterDefinition: AppRouterDefinition;
}

export default function AppRouterListener(props: AppRouterListenerProps) {
    const routeMatch = useRouteMatch();
    const appContext = useAppContext();
    const appBreadcrumbsContext = useAppBreadcrumbsContext();
    const url = routeMatch.url;
    const authenticationContext = useAuthenticationContext();

    const setRouteMatch = () => {
        const hideHeader = props.appRouterDefinition.hideHeader ?? false;
        const zeigeAppHeader = appContext.zeigeAppHeader;
        if (hideHeader === zeigeAppHeader) {
            appContext.setzeZeigeAppHeader(!hideHeader);
        }

        appBreadcrumbsContext.setRouteMatch(routeMatch.path, routeMatch.url, routeMatch.params);
        authenticationContext?.setAllowAnonymous(props.appRouterDefinition.unauthorized ?? false);
    };

    useEffect(setRouteMatch, [url]);
    return <></>;
}
